import React, { MouseEventHandler } from 'react'

interface Props {
    type: string
    head?: React.ReactNode
    headText?: string
    mainClass: string
    hasCaret?: boolean
    removable: boolean
    onRemove?: MouseEventHandler
    disabled: boolean
    children?: React.ReactNode
}

class Selector extends React.Component<Props> {
    public static defaultProps = {
        mainClass: 'dropdown',
        hasCaret: true,
        removable: false,
        disabled: false,
    }

    public render() {
        let head = this.props.head
        if (!head) {
            head = (
                <span className="capitalize">
                    {this.props.type}: {this.props.headText || 'choose'}
                </span>
            )
        }

        return (
            <div className={this.props.mainClass}>
                <div className="btn-group">
                    <button
                        className="dropdown-toggle btn btn-default"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        disabled={this.props.disabled}
                        style={{ minWidth: '120px' }}
                    >
                        {head}
                        {this.props.hasCaret ? <b className="caret tw-ml-4" /> : ''}
                    </button>
                    {this.props.children}
                    {this.props.removable ? (
                        <button className="btn btn-default" onClick={this.props.onRemove}>
                            <i className="fa fa-times-circle" />
                        </button>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        )
    }
}

export default Selector
